export default __webpack_public_path__ + "static/media/99acresImages.8059371e.png";